import React from 'react';

// eslint-disable-next-line no-restricted-imports
import { Helmet as RNHelmet } from 'react-helmet-async';

import { fullBrandName } from 'utils/environment';

export const Helmet: React.FC<React.PropsWithChildren<{ title?: string | null | undefined }>> = ({
  title,
  children,
}) => {
  const defaultTitle = fullBrandName();
  const titleTemplate = `%s - ${fullBrandName()}`;
  return (
    <RNHelmet
      titleTemplate={titleTemplate}
      defaultTitle={defaultTitle}
      title={title || undefined}
      children={children}
    />
  );
};
